import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export default function useRecaptcha() {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const waitForExecuteRecaptcha = async (timeout = 5000) => {
        const interval = 200;
        const max = Math.ceil(timeout / interval);
        for (let i = 0; i < max; i++) {
            // eslint-disable-next-line no-console
            console.debug('[useRecaptcha] poll', { i, executeRecaptcha: !!executeRecaptcha, grecaptcha: typeof (window as any).grecaptcha !== 'undefined' });
            if (executeRecaptcha) return executeRecaptcha;
            // eslint-disable-next-line no-await-in-loop
            await new Promise((res) => setTimeout(res, interval));
        }
        // eslint-disable-next-line no-console
        console.error('[useRecaptcha] executeRecaptcha not available after polling', { grecaptcha: (window as any).grecaptcha, url: window.location.href });
        throw new Error('reCAPTCHA 실행 불가');
    };

    const getToken = async (action = 'action') => {
        const exe = await waitForExecuteRecaptcha();
        return exe(action);
    };

    return { getToken, waitForExecuteRecaptcha };
}
